import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { intersect } from '@/helper/intersect';

createApp(App)
    .use(router)
    .directive('intersect', intersect)
    .mount('#app')
